import { Checkbox } from 'antd';
import { Form } from 'antd';

export const PrivateLabelFormItem = () => {
  const form = Form.useFormInstance();

  return (
    <Form.Item
      label='Private Label'
      name='isPrivateLabel'
      valuePropName='checked'
      colon={false}
      labelAlign='right'
      labelCol={{
        flex: '85px',
      }}
      wrapperCol={{
        flex: 1,
      }}
    >
      <Checkbox
        onChange={(e) => {
          if (!e.target.checked) form?.setFieldsValue({ supplierId: null });
        }}
      />
    </Form.Item>
  );
};
